/** Sibling .webp / .avif files generated next to originals in public/. */

export function altImageUrls(src) {
  const q = src.indexOf("?");
  const path = q === -1 ? src : src.slice(0, q);
  const dot = path.lastIndexOf(".");
  const base = dot === -1 ? path : path.slice(0, dot);
  return {
    avif: `${base}.avif`,
    webp: `${base}.webp`,
    fallback: src,
    base,
  };
}

/** CSS background stack: PNG/JPEG fallback, then image-set for AVIF/WebP. */
export function cssImageSet(src, ext = "png") {
  const { avif, webp, fallback } = altImageUrls(src);
  const type = ext === "jpg" || ext === "jpeg" ? "image/jpeg" : `image/${ext}`;
  return `url("${fallback}");
          background-image: image-set(url("${avif}") type("image/avif"), url("${webp}") type("image/webp"), url("${fallback}") type("${type}"))`;
}

/** Single background-image value for React inline styles. */
export function cssImageSetValue(src, ext = "png") {
  const { avif, webp, fallback } = altImageUrls(src);
  const type = ext === "jpg" || ext === "jpeg" ? "image/jpeg" : `image/${ext}`;
  return `image-set(url("${avif}") type("image/avif"), url("${webp}") type("image/webp"), url("${fallback}") type("${type}"))`;
}

export function cssImageSetMobile(src, width, ext = "png") {
  const { base, fallback } = altImageUrls(src);
  const type = ext === "jpg" || ext === "jpeg" ? "image/jpeg" : `image/${ext}`;
  return `url("${fallback}");
          background-image: image-set(url("${base}-${width}.avif") type("image/avif"), url("${base}-${width}.webp") type("image/webp"), url("${fallback}") type("${type}"))`;
}
